import moment from 'moment'
import React from 'react'

export const getWithdrawRowStatus = ({ method, revertedAt, WithdrawRequest }) => {
  const request = Array.isArray(WithdrawRequest) ? WithdrawRequest[0] : null
  const rejected = Boolean(revertedAt) || (request && request.status === 2)

  if (rejected) {
    return {
      label: method === 'INTERNAL' ? 'Đã thu hồi' : 'Đã từ chối',
      tone: 'danger',
      reverted: true,
      at: revertedAt || null,
      message: (request && request.message) || '',
    }
  }

  if (request && request.status === 0) {
    return {
      label: 'Đang xử lý',
      tone: 'warning',
      reverted: false,
      at: null,
      message: '',
    }
  }

  return {
    label: 'Thành công',
    tone: 'success',
    reverted: false,
    at: null,
    message: '',
  }
}

export const WithdrawStatusCell = (props) => {
  const status = getWithdrawRowStatus(props)

  return (
    <td className={`text-center text-${status.tone}`}>
      <strong>{status.label}</strong>
      {status.at ? (
        <>
          <br />
          <span>{moment(status.at).format('DD/MM/YYYY HH:mm')}</span>
        </>
      ) : null}
      {status.message ? (
        <>
          <br />
          <span>{status.message}</span>
        </>
      ) : null}
    </td>
  )
}
